let logon_template = 'sign-in.vue';
let background_images = null;
let syslogo = null;
let menu_class = 'el-menu-vertical-demo';
let functions = false;
let enroll = false;
let report_name = '会议统计';
let use_label = false;
let no_default_group = false;
let hidden_group = ['学院管理','会议室','会议室会议'];
let auto_record = 0;
let cohost = true;
let should_show_admin = true;
let show_video_analysis = false; // 视频分析菜单:默认关,仅特定校开
// 隐藏"开启直播"开关:默认显示,仅特定校隐藏。
// 同济的后端全局参数 enable_live=1,所有会议一律开直播,这个开关勾与不勾
// 结果都一样(见 TencentMeetingClass: enable_live = 全局 || option_live),
// 留在界面上只会让老师误以为可以控制。
// 刻意写在代码里而不是放 env:env/ 目录是 gitignored 的,放那儿这个改动
// 在版本控制里看不见,换机器构建就会丢。
let hide_option_live = false;
// 开放接口(接口凭证后台、API 文档页、免登录临时回放链接):默认关,仅后端部署了
// OpenApiController 的学校开启。2026-09 巡检 9 所学校,只有同济有这套后端;
// 其它学校若不关,管理员后台会多出一个点进去就报错的"接口凭证"菜单。
let show_open_api = false;
let edit_template = '';

//以下内容需要进行修改或者增加
if (process.env.VUE_APP_API_ORG === 'sufe2') {
    logon_template = 'sign-in-sufe.vue';
} else if (process.env.VUE_APP_API_ORG === 'sjtu') {
    logon_template = 'sign-in-sjtu.vue';
    background_images = ["bg1.jpg", "bg2.jpg", "bg3.jpg", "bg4.jpg", "bg5.jpg", "bg6.jpg", "bg7.jpg"]

    // 修改 <meta name="viewport" content="width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,user-scalable=no" /> 中的 user-scalable=no 为 user-scalable=yes, maximum-scale=1 为 maximum-scale=5
    const dom = document.querySelector('meta[name="viewport"]');
    dom.setAttribute('content', 'width=device-width,initial-scale=1,maximum-scale=5,minimum-scale=1,user-scalable=yes');

} else if (process.env.VUE_APP_API_ORG === 'tsied') {
    functions = true;
    enroll = true;
    hidden_group = [];
    edit_template = 'edit-bnu';
    logon_template = 'sign-in-tsi.vue';
} else if (process.env.VUE_APP_API_ORG === 'shu') {
    logon_template = 'sign-in.vue';
} else if (process.env.VUE_APP_API_ORG === 'sou') {
    hidden_group = ['学院管理'];
    logon_template = 'sign-in.vue';
    functions = true;
} else if (process.env.VUE_APP_API_ORG === 'age06') {
    logon_template = 'sign-in-shec.vue';
    syslogo = 'syslogo.png';
} else if (process.env.VUE_APP_API_ORG === 'fudan') {
    report_name = '报表';
} else if (process.env.VUE_APP_API_ORG === 'ecust') {
    logon_template = 'sign-in.vue';
} else if (process.env.VUE_APP_API_ORG === 'publics') {
    logon_template = 'sign-in-public.vue';
    syslogo = 'syslogo.png';
} else if (process.env.VUE_APP_API_ORG === 'shanghaitech') {
    logon_template = 'sign-in-shanghaitech.vue';
    menu_class = "el-menu-light-gray"
    document.getElementsByTagName('body')[0].style.setProperty('--sign-in-primary', '#a10003')
    document.getElementsByTagName('body')[0].style.setProperty('--sign-in-primary-hover', '#de3d40')
} else if (process.env.VUE_APP_API_ORG === 'sta') {
    menu_class = "el-menu-light-gray";
    should_show_admin=false;
    document.getElementsByTagName('body')[0].style.setProperty('--sign-in-primary', '#832E61')
    document.getElementsByTagName('body')[0].style.setProperty('--sign-in-primary-hover', '#c0448b')
} else if (process.env.VUE_APP_API_ORG === 'shwfl') {
    menu_class = "el-menu-light-gray";
    functions = true;
} else if (process.env.VUE_APP_API_ORG === 'tongji') {
    background_images =
        ['tongji001.jpg', 'tongji002.jpg', 'tongji003.jpg'];
    should_show_admin = false;
    show_video_analysis = true;
    hide_option_live = true;
    show_open_api = true;
} else if (process.env.VUE_APP_API_ORG === 'ecnu' || process.env.VUE_APP_API_ORG === 'ecnu-yjs') {
    logon_template = 'sign-in-ecnu.vue';
} else if (process.env.VUE_APP_API_ORG === 'seu') {
    background_images =
        ['seu-bg-1.jpg', 'seu-bg-2.jpg', 'seu-bg-3.jpg'];
} else if (process.env.VUE_APP_API_ORG === 'bnu') {
    functions = true;
    background_images = ['bnu-bg1.jpg', 'bnu-bg2.jpg', 'bnu-bg3.jpg'];
    no_default_group = true;
    cohost = false;
    edit_template = 'edit-bnu';
} else if (process.env.VUE_APP_API_ORG === 'mhedu') {
    menu_class = "el-menu-light-gray"
    use_label = true;
    auto_record= 2;
    hidden_group = ['用户类型','会议室管理','会议室','会议室会议','背景图片','代建会议'];

    document.getElementsByTagName('body')[0].style.setProperty('--sign-in-primary', '#a10003')
    document.getElementsByTagName('body')[0].style.setProperty('--sign-in-primary-hover', '#de3d40')
} else if (process.env.VUE_APP_API_ORG === 'ceibs') {
    menu_class = "el-menu-light-gray";
}

//以上内容进行修改和增加
//这是交大特殊用法，一定要邮件地址登录
//其他学校可以多重方式登录
const use_id = process.env.VUE_APP_API_ORG !== 'sjtu';
const signin = process.env.VUE_APP_API_ROOT ? process.env.VUE_APP_API_ROOT : window.location.origin + '/api/v1'
const signin_url = signin.replace('api/v1', 'sign-in')
const host_url = signin.replace('api/v1', '');
const home_page = process.env.VUE_APP_HOME ? process.env.VUE_APP_HOME : '/calendar';
const edit_page = process.env.VUE_APP_EDIT ? process.env.VUE_APP_EDIT : false;

const hideMenu = (name) => {
    // 判断 hidden_group 中是否包含 name
    return hidden_group.indexOf(name) > -1
}

const encrypt_token = !!process.env.VUE_APP_ENCRYPT_TOKEN;
// 导出内容
export default {
    //如果设置sso，则不显示登录页面，直接跳转到sso的页面
    sso: process.env.VUE_APP_SSO_LOGIN_REDIRECT,
    sso_out: process.env.VUE_APP_SSO_LOGOUT_REDIRECT,
    //学校的org缩写
    org: process.env.VUE_APP_API_ORG,
    //使用user_id还是使用email
    use_id: use_id,
    //登录的template
    logon_template: logon_template,
    //oauth的设置
    oauth: process.env.VUE_APP_OAUTH_LOGIN,
    oauth_out: process.env.VUE_APP_OAUTH_LOGOUT,
    oauth_title: process.env.VUE_APP_OAUTH_TITLE,
    oauth_picture: process.env.VUE_APP_OAUTH_PICTURE,
    oauth_helper: process.env.VUE_APP_OAUTH_HELPER,
    //微信的设置
    wx_redirect: process.env.VUE_APP_API_WX_CORP_REDIRECT,
    //这个不用了
    h323: process.env.VUE_APP_ORG_H323,
    //背景图片，这个也不用了。可以自己上传
    background_images: background_images,
    //系统的logo
    syslogo: syslogo,
    //系统登录的url
    signin_url: signin_url,
    //系统登录的url
    host_url: host_url,

    no_qrcode: process.env.VUE_APP_NO_QRCODE,
    home_page: home_page,
    edit_page: edit_page,
    no_indicate: process.env.VUE_APP_NO_INDICATE,
    build_time: process.env.VUE_APP_BUILD_TIME,
    //多学校设置
    extra: process.env.VUE_APP_MULTI_UNIVERSITY,
    //不使用zoom
    no_zoom: process.env.VUE_APP_API_NO_ZOOM,
    //不使用腾讯
    no_tencent: process.env.VUE_APP_API_NO_TENCENT,
    //不使用we-link
    no_welink: process.env.VUE_APP_API_NO_WELINK,
    //腾讯使用contract
    use_contact: process.env.VUE_APP_USE_CONTACT,
    //使用微信
    use_wechat: process.env.VUE_APP_USE_WECHAT,
    wechat_appid: process.env.VUE_APP_WECHAT_APPID,
    wechat_agentid: process.env.VUE_APP_WECHAT_AGNETID,
    //menu
    menu_class: menu_class,
    //sign-in-functions
    sign_in_functions:functions,
    //allow_enroll
    allow_enroll:enroll,
    //homejs name
    menu_report_name:report_name,
    //只有闵行教育局使用label
    use_label:use_label,
    no_default_group:no_default_group,
    auto_record:auto_record,
    cohost:cohost,
    //上海科技大学使用course
    course: process.env.VUE_APP_USE_COURSE,
    hidden: hideMenu,
    encrypt_token:encrypt_token,
    should_show_admin:should_show_admin,
    show_video_analysis: show_video_analysis,
    hide_option_live: hide_option_live,
    show_open_api: show_open_api,
    hide_option_internal: process.env.VUE_APP_HIDE_OPTION_INTERNAL,

    email_required: !!process.env.VUE_APP_EMAIL_REQUIRED,
    mobile_required: process.env.VUE_APP_MOBILE_REQUIRED,

    // 如果另有编辑页面，可以在这里设置
    edit_template: edit_template,

}
